import Table from 'react-bootstrap/Table';
import Papa from 'papaparse';
import React, { useState, useEffect } from 'react';
import FileInput from './FileInput';
import MSATable from './Table';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../Main.css'

function MSAType1() {
    let totalNoofColumns = 15;
    let totalNoofRows = 50;
    let inputHeaders = ['Messwert'];
    let inputData = [[11.56164127], [11.58401799], [11.54149972], [11.65156101], [11.43797065], [11.63581563], [11.52981026], [11.65301734], [11.34747965], [11.48693071], [11.64969438], [11.59804141], [11.43191137], [11.59623184], [11.8071965], [11.49859131], [11.56565067], [11.38979765], [11.66775589], [11.54983073], [11.52068082], [11.47550766], [11.47282369], [11.64161937], [11.29285077], [11.61561316], [11.65593484], [11.45118888], [11.55778622], [11.5316529]]//[[18.77], [18.34], [18.83], [19.51], [18.19], [20.74], [20.39], [17.47], [20.91], [21.72], [21.55], [19.59], [21.56], [20.63], [21.07], [21.52], [21.17], [20.07], [22.66], [21.26], [20.29], [17.71], [19.36], [18.66], [22.14], [21.79], [19.62], [21.03], [19.87], [20.85]]
    
    let defaultHeaders = [""]
    let defaultData = []
    for (let i = 0; i < inputHeaders.length; i++) {
        defaultHeaders.push(inputHeaders[i]);
    }

    for (let i = defaultHeaders.length + 1; i <= totalNoofColumns + 1; i++) {
        defaultHeaders.push("")
    }

    for (let i = 0; i < inputData.length; i++) {
        let row = [i + 1];
        for (let j = 0; j < inputData[i].length; j++) {
            row.push(inputData[i][j]);
        }
        defaultData.push(row);
    }

    for (let i = defaultData.length - 1; i < totalNoofRows; i++) {
        let newRow = [i]
        for (let j = 0; j < totalNoofColumns; j++) {
            newRow.push("")
        }
        defaultData.push(newRow)
    }

    for (let i = 0; i < totalNoofRows; i++) {
        for (let j = defaultData[i].length; j <= totalNoofColumns; j++) {
            defaultData[i].push("");
        }
    }

    let emptyHeaders = []
    let emptyData = [];
    for (let i = 0; i <= totalNoofColumns; i++) {
        emptyHeaders.push("")
    }
    for (let i = 0; i < totalNoofRows; i++) {
        let row = [i + 1];
        for (let j = 0; j < totalNoofColumns; j++) {
            row.push("");
        }
        emptyData.push(row);
    }

    const [makeCalculationsCalled, setMakeCalculationsCalled] = useState(0)
    const [pyPlot, setPyPlot] = useState()
    const [csvData, setCsvData] = useState(defaultData);
    const [headers, setHeaders] = useState(defaultHeaders);
    const [variableNo, setVariableNo] = useState(1);

    let data = csvData.map((data, index) => (data[variableNo]));
    data = data.filter(value => value !== '' && !isNaN(parseFloat(value))).map(value => parseFloat(value))

    const [actualData, setActualData] = useState(data);
    const [LSL, setLSL] = useState(11);
    const [USL, setUSL] = useState(12);
    const [reference, setReference] = useState(11.5);
    const [tolerance1, setTolerance1] = useState(20);
    const [mittelwert, setMittelwert] = useState(0);
    const [k, setK] = useState(4);
    const [stdDev, setStdDev] = useState(0);
    const [bias, setBias] = useState(0);
    const [tWert, setTWert] = useState(0);
    const [pWert, setPWert] = useState(0);
    const [Cg, setCg] = useState(0);
    const [Cgk, setCgk] = useState(0);
    const [product, setProduct] = useState("")
    const [device, setDevice] = useState("")
    const [productFeature, setProductFeature] = useState("")
    const [standard, setStandard] = useState("")
    const [date, setDate] = useState("")
    const [reportCreator, setReportCreator] = useState("")

    const updateCSVData = (event) => {
        updateVariableNo(event.ColNo)
        console.log("eventColNo", event.ColNo)
        setCsvData(event.data)
        setClickedButton(event.ColNo);
    }

    const updateCSVHeader = (event) => {
        console.log(headers);
        let headers2 = [...headers];
        setHeaders(event.Headers)
        console.log("Updating headers: ", headers2, headers)
    }

    useEffect(() => {
        let data = csvData.map((data, index) => (data[variableNo]));
        data = data.filter(value => value !== '' && !isNaN(parseFloat(value)))
        data = data.map(value => parseFloat(value))
    }, [csvData])

    useEffect(() => {
            console.log(variableNo,actualData)
            makeCalculations();
    }, [actualData, k, LSL, USL, reference, tolerance1]);

    window.onafterprint = function () {
        let leftColObj = document.getElementById('einstellungen-leftCol');
        let rightColObj = document.getElementById('einstellungen-rightCol');
        leftColObj.classList.remove("col-sm-6");
        rightColObj.classList.remove("col-sm-6");
        leftColObj.classList.add("col-sm-12");
        rightColObj.classList.add("col-sm-12");

        let einstellungenObj = document.getElementById('einstellungen');
        einstellungenObj.classList.add("container");

        var distributionPlot = window.document.getElementById("distributionPlot");
        while (distributionPlot.children.length > 0) {
            distributionPlot.removeChild(distributionPlot.firstChild);
        }
        distributionPlot.classList.remove("justify-content-left");
        distributionPlot.classList.add("justify-content-center");
        let tablePlotsObj = document.getElementById('tablePlots');
        tablePlotsObj.classList.add("justify-content-center");
        tablePlotsObj.classList.add("container");
        window.Bokeh.embed.embed_item(pyPlot, "distributionPlot")

        let statistikenObj = document.getElementById('statistiken')
        statistikenObj.classList.add("container");
        let statistikenLeftColObj = document.getElementById('statistikenLeftCol');
        let statistikenRightColObj = document.getElementById('statistikenRightCol');
        statistikenLeftColObj.classList.remove("col-sm-6");
        statistikenRightColObj.classList.remove("col-sm-6");
        statistikenLeftColObj.classList.add("col-sm-12");
        statistikenRightColObj.classList.add("col-sm-12");
        
        let headerObj = document.getElementById('headerwrap')
        if(headerObj){
            headerObj.style.display = "block";
        }
        let footerObj = document.getElementById('footerwrap')
        if(footerObj){
            footerObj.style.display = "block";
        }
    };

    useEffect(() => {
        document.addEventListener('updateCSVData', updateCSVData);
        return () => { document.removeEventListener('updateCSVData', updateCSVData); };
    }, [])

    useEffect(() => {
        document.addEventListener('updateCSVHeader', updateCSVHeader);
        return () => { document.removeEventListener('updateCSVHeader', updateCSVHeader); };
    }, [])

    const handleFileChange = (file) => {
        Papa.parse(file, {
            complete: (result) => {
                const [header, ...csvData] = result.data; // Extract the first row as header
                for (let i = header.length; i < 10; i++) {
                    header.push("")
                }
                setHeaders(['', ...header]); // Set the headers to the state
                var newRowsList = [];
                var rowno = 1;
                csvData.forEach((row) => {
                    var cols = [rowno]
                    rowno += 1;
                    row.forEach((col) => {
                        if (!(col instanceof Array) && (col !== "")) {
                            cols.push(col)
                        }
                    })
                    let preColsLength = cols.length;
                    for (let i = cols.length; i <= 10; i++) {
                        cols.push("")
                    }
                    if (preColsLength > 1) {
                        newRowsList.push(cols)
                    }
                })
                for (let i = header.length; i <= 10; i++) {
                    header.push("")
                }
                setCsvData(newRowsList);
                updateVariableNo(1)
                //setVariableNo(1);
            },
        });
    };


    const printIt = async () => {
        let leftColObj = document.getElementById('einstellungen-leftCol');
        let rightColObj = document.getElementById('einstellungen-rightCol');
        leftColObj.classList.remove("col-sm-12");
        rightColObj.classList.remove("col-sm-12");
        leftColObj.classList.add("col-sm-6");
        rightColObj.classList.add("col-sm-6");

        let einstellungenObj = document.getElementById('einstellungen');
        einstellungenObj.classList.remove("container");
        
        var distributionPlot = window.document.getElementById("distributionPlot");
        distributionPlot.classList.remove("justify-content-center");
        distributionPlot.classList.add("justify-content-left");
        while (distributionPlot.children.length > 0) {
            distributionPlot.removeChild(distributionPlot.firstChild);
        }
        let tablePlotsObj = document.getElementById('tablePlots');
        tablePlotsObj.classList.remove("container");
        tablePlotsObj.classList.remove("justify-content-center");
        tablePlotsObj.classList.add("justify-content-left");
        window.Bokeh.embed.embed_item(pyPlot, "distributionPlot")

        let statistikenObj = document.getElementById('statistiken')
        statistikenObj.classList.remove("container");
        let statistikenLeftColObj = document.getElementById('statistikenLeftCol');
        let statistikenRightColObj = document.getElementById('statistikenRightCol');
        statistikenLeftColObj.classList.remove("col-sm-12");
        statistikenRightColObj.classList.remove("col-sm-12");
        statistikenLeftColObj.classList.add("col-sm-6");
        statistikenRightColObj.classList.add("col-sm-6");
        
        let headerObj = document.getElementById('headerwrap')
        if(headerObj){
            headerObj.style.display = "none";
        }
        let footerObj = document.getElementById('footerwrap')
        if(footerObj){
            footerObj.style.display = "none";
        }
        
        setTimeout(() => {
            window.print();
        }, 10);
        return true;
    }

    const clearData = (option) => {
        if (option === 'reset') {
            setHeaders(emptyHeaders);
            setCsvData(emptyData);
            const eventResetData = new Event('resetData');
            document.dispatchEvent(eventResetData);
        }
        else {
            const eventN1 = new Event('updateCSVHeader');
            eventN1.Headers = defaultHeaders
            document.dispatchEvent(eventN1);
            const eventN = new Event('updateCSVData');
            eventN.ColNo = 1;
            eventN.data = defaultData
            document.dispatchEvent(eventN);
        }
    }

    function updateVariableNo(varNo) {
        let data = csvData.map((data, index) => (data[varNo]));
        data = data.filter(value => value !== '' && !isNaN(parseFloat(value))).map(value => parseFloat(value))
        setVariableNo(varNo);
        setClickedButton(varNo);
        setActualData(data);
    }

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    
    async function sleep(ms) {
        return await delay(ms); // Pause execution for 1 second (1000 milliseconds)
    }
    
    const makeCalculations = async () => {
        if(makeCalculationsCalled === 0){
            setMakeCalculationsCalled(1)
        }
        else{
            console.log('Returned')
            return 0
        }
        var distributionPlot = document.getElementById("distributionPlot");
        if (isNaN(LSL) || isNaN(USL) || isNaN(k)) {
            return 0;
        }
        console.log(actualData)
        distributionPlot.innerHTML = "Loading Chart ...";
        const url = 'https://django.qm-datalab.com/MSAType1';
        const params = {
            data: actualData,
            lsl: LSL,
            usl: USL,
            k: k,
            tolerance: tolerance1,
            reference: reference,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height
        };
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        })
            .then(response => response.json())
            .then(data => {
                console.log("dataJSON", data)
                setMittelwert(data["mittlevert"].toFixed(5))
                setStdDev(data["stdDeviation"])
                setBias(data["Bias"])
                setTWert(data["T"])
                setPWert(data["P"])
                setPyPlot(data['pyplot'])
                //setTolerance1(data["tolerance"])
                setCg(data["Cg"])
                setCgk(data["Cgk"])
                
                // Select all elements with the class 'bk-Figure'
                const elements = document.querySelectorAll('.bk-Figure');

                // Loop through the selected elements and remove each one
                elements.forEach(element => {
                    element.remove();
                });
                distributionPlot.innerHTML = "";
                window.Bokeh.embed.embed_item(data['pyplot'], "distributionPlot");
                setMakeCalculationsCalled(0);
                
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setMakeCalculationsCalled(0);
            });
    }

    const handleInputChange = (event) => {
        let id = event.target.id;
        let value = event.target.value;
        if (id !== "distribution") {
            if (value.indexOf(".") > -1) {
                value = parseFloat(value)
            }
            else {
                value = parseInt(value)
            }
        }
        console.log("ID: ", id, value)
        switch (id) {
            case 'LSL':
                setLSL(value);
                break;
            case 'USL':
                setUSL(value);
                break;
            case 'k':
                setK(value);
                break
            case 'tolerance':
                setTolerance1(value);
                break
            case 'tolerance1':
                setTolerance1(value);
                break
            case 'reference':
                setReference(value);
                break
            default:
                console.log(id);
        }
    };

    const [clickedButton, setClickedButton] = useState(1);
    return (
        <>
            <Container id="docHeader" className='noprint'>
                <Row >
                    <Col className='headingText'>
                        Dateninput
                    </Col>
                </Row>
                <Row>
                    <Col className='text-start' xs={12} sm={12} md={6} xl={6} xxl={6}>
                        <FileInput onFileChange={handleFileChange} />
                    </Col>
                    <Col className='text-start' xs={6} sm={6} md={3} xl={3} xxl={3} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <Button variant="light" size='medium' className='links' onClick={() => clearData("reset")}>Alle Daten löschen</Button>
                    </Col>
                    <Col className='text-start' xs={6} sm={6} md={3} xl={3} xxl={3} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <Button variant="light" size='medium' className='links' onClick={() => clearData("default")}>Beispieldaten laden</Button>
                    </Col>
                </Row>
            </Container>
            <Container id='MSATable' className='noprint'>
                <Row>
                    <Col>
                        <MSATable data={Array.from(csvData)} headers={[...headers]} />
                    </Col>
                </Row>
            </Container>
            <Container className='mx-auto noprint' id='variablen'>
                <Row>
                    <Col sm='auto' className='text-start headingText' style={{ paddingTop: '10px', paddingBottom: '5px' }} id='variablen'>
                        Variablen
                    </Col>
                </Row>
                <Row>
                    <Col className='text-start ml-5 mr-5' style={{ paddingTop: '3px', paddingBottom: '3px', paddingLeft: '5px', paddingRight: '5px' }}>
                        {headers.map((header, index) => { if (header !== "") { return (<Button key={index} size='sm' className={`headerLinks ${clickedButton === index ? 'clicked' : ''}`} onClick={() => { setClickedButton(index); updateVariableNo(index); }}>{header}</Button>) } })}
                    </Col>
                </Row>
                <hr style={{ borderTop: '3px solid gray' }} className='my-1' />
            </Container>
            <Container className='printable my-2 justify-content-center' id="einstellungen">
                <Row >
                    <Col sm='auto' className='text-start headingText'>
                        Einstellungen
                    </Col>
                </Row>
                <Row className='justify-content-center'>
                    <Col id='einstellungen-leftCol' xs={12} sm={12} md={6} xl={6} xxl={6} className='text-start justify-content-center' style={{ borderTop: '1px solid gray', fontSize: '1rem', paddingTop: 10, paddingBottom: 10 }}>
                        <Row className='text-start justify-content-center'>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Untere Spez. Grenze<Form.Control size="sm" type="number" id="LSL" defaultValue={LSL} onChange={handleInputChange} /></Col>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Obere Spez. Grenze<Form.Control size="sm" type="number" id="USL" defaultValue={USL} onChange={handleInputChange} /></Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Referenzwert (Normal)<Form.Control size="sm" type="number" id="reference" defaultValue={reference} onChange={handleInputChange} /></Col>
                        </Row>
                        <Row className='text-start justify-content-center'>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>% der Toleranz<Form.Control size="sm" type="number" id="tolerance" defaultValue={tolerance1} onChange={handleInputChange} /></Col>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>k<Form.Control size="sm" type="number" id="k" defaultValue={k} onChange={handleInputChange} /></Col>
                        </Row>
                    </Col>
                    <Col id='einstellungen-rightCol' xs={12} sm={12} md={6} xl={6} xxl={6} className='text-start justify-content-center' style={{ borderTop: '1px solid gray', borderLeft: '1px solid gray', fontSize: '1rem', paddingTop: 10, paddingBottom: 10 }}>
                        <Row>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Produkt<Form.Control size="sm" type="number" id="product" defaultValue={product} onChange={handleInputChange} /></Col>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Messgerät<Form.Control size="sm" type="number" id="device" defaultValue={device} onChange={handleInputChange} /></Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Produktmerkmal (Normal)<Form.Control size="sm" type="number" id="productFeature" defaultValue={productFeature} onChange={handleInputChange} /></Col>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Messnormal / Referenz<Form.Control size="sm" type="number" id="standard" defaultValue={standard} onChange={handleInputChange} /></Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Datum der Messungen<Form.Control size="sm" type="number" id="date" defaultValue={date} onChange={handleInputChange} /></Col>
                            <Col xs={6} sm={6} md={6} xl={6} xxl={6}>Berichtersteller<Form.Control size="sm" type="number" id="reportCreator" defaultValue={reportCreator} onChange={handleInputChange} /></Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

            <hr style={{ borderTop: '3px solid gray' }} />

            <Container id="tablePlots" className='my-5 justify-content-center' style={{ textAlign: 'center'}}>
                <Row id='plotRow'>
                    <Col md={3} xl={3} xxl={3} style={{ padding: 0 }} ></Col>
                    <Col xs={12} sm={12} md={6} xl={6} xxl={6} style={{ padding: 0 }} >
                        <div id='distributionPlot'></div>
                    </Col>
                    <Col md={3} xl={3} xxl={3} style={{ padding: 0 }} ></Col>
                </Row>
            </Container>
            <Container id='statistiken'>
                <Row className='justify-content-center'>
                    <Col xs={12} sm={12} md={5} xl={5} xxl={5} id='statistikenLeftCol'>
                        <Row>
                            <Col id='textStatistiken' className='text-center' style={{ whiteSpace: 'nowrap', fontWeight: 'bold', fontSize: '14pt', backgroundColor: 'black', color: 'white' }}>
                                Statistiken
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ padding: 0, margin: 0 }}>
                                <Table striped hover size='sm' className='custom-table'>
                                    <tbody>
                                        <tr><td>&nbsp;</td><td className='text-left'>Referenzwert</td><td className='text-right'>{reference}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>Stichprobengröße</td><td className='text-right'>{actualData.length}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>Mittelwert</td><td className='text-right'>{mittelwert}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>Standardabweichung</td><td className='text-right'>{stdDev.toFixed(5)}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>Toleranz</td><td className='text-right'>{USL - LSL}</td><td>&nbsp;</td></tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={5} xl={5} xxl={5} style={{ borderLeft: '6px solid white' }}  id='statistikenRightCol'>
                        <Row>
                            <Col id='textMessmittelfähigkeit' className='text-center' style={{ whiteSpace: 'nowrap', fontWeight: 'bold', fontSize: '14pt', backgroundColor: 'black', color: 'white' }}>
                                Messmittelfähigkeit
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ padding: 0, margin: 0 }}>
                                <Table striped bordered hover size='sm' className='custom-table'>
                                    <tbody>
                                        <tr><td>&nbsp;</td><td className='text-left'>Syst. Abweichung</td><td className='text-right'>{bias.toFixed(5)}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>T-Wert</td><td className='text-right'>{tWert.toFixed(5)}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>P-Wert</td><td className='text-right'>{pWert.toFixed(5)}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>Cg</td><td className='text-right'>{Cg.toFixed(5)}</td><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td><td className='text-left'>Cgk</td><td className='text-right'>{Cgk.toFixed(5)}</td><td>&nbsp;</td></tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={1} sm={1}></Col>
                </Row >
            </Container >
            <Container id='printButton' className='noprint my-5'>
                <Button variant="primary" onClick={() => printIt()}>Bericht drucken oder runterladen</Button>{' '}
            </Container >
            <Container className='my-5 noprint'>
                <Row>
                    <Col>
                        <Accordion defaultActiveKey="0" size='sm'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Was ist eine Messsystemanalyse - msa Typ 1?</Accordion.Header>
                                <Accordion.Body className='text-left' style={{ visibility: 'visible' }}>
                                    Die Messsystemanalyse - msa Typ 1 ist eine Methode zur Bewertung und Überwachung der Genauigkeit und Zuverlässigkeit von Messsystemen. Sie identifiziert systematische Abweichungen von Messungen und ermöglicht die Optimierung von Messprozessen
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Warum ist die Messsystemanalyse wichtig?</Accordion.Header>
                                <Accordion.Body className='text-left' style={{ visibility: 'visible' }}>
                                    Die Messsystemanalyse ist wichtig, weil sie sicherstellt, dass Messungen zuverlässig und genau sind. Dies ist entscheidend für die Qualität von Produkten und Prozessen.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Bietet QM-Datalab ein kostenloses Analyse Tool für die Messsystemanalyse Typ 1?</Accordion.Header>
                                <Accordion.Body className='text-left' style={{ visibility: 'visible' }}>
                                    Ja, QM-Datalab bietet ein kostenloses Analyse Tool für die Messsystemanalyse Typ 1. Du kannst deine Messdaten einfach online eingeben und das Tool erstellt Analysen, Kennwerte und Diagramme für dich
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>Welche Kenngrößen sind in der Messsystemanalyse Typ 1 besonders relevant?</Accordion.Header>
                                <Accordion.Body className='text-left' style={{ visibility: 'visible' }}>
                                    In der Messsystemanalyse Typ 1 sind die Kenngrößen Cg und Cgk besonders relevant. Sie ermöglichen eine präzise Beurteilung der Leistung des Messsystems.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>Wie hilft die Messsystemanalyse Typ 1 bei der Qualitätssteigerung?</Accordion.Header>
                                <Accordion.Body className='text-left' style={{ visibility: 'visible' }}>
                                    Die Messsystemanalyse Typ 1 hilft bei der Qualitätssteigerung, indem sie systematische Abweichungen von Messungen identifiziert und es ermöglicht, diese zu korrigieren. Dadurch werden Genauigkeit und Zuverlässigkeit der Messungen verbessert.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
            <Container className='noprint'>
                <Row>
                    <Col>
                        <Row>
                            <Col className='heading text-left'>
                                Messsystem Analyse Type 1 online und kostenlos mit dem Analyse Tool von QM-Datalab
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left'>
                                Analysiere unkompliziert und kostenlos online deine Messdaten. Füge einfach deine Daten in das QM-Datalab Tool ein, wähle aus welche Daten du auswerten möchtest und QM-Datalab erstellt dir alle benötigten Analysen, Kennwerte und Diagramme.
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left my-3'>
                                Die großen Vorteile von QM-Datalab
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ul className="list-disc pl-16">
                                    <li className='text-left'>Von QM-Manager für QM-Manager: Genau die Analysen, die du brauchst</li>
                                    <li className="text-left">100% Datensicherheit: Die Analysen werden nur auf deinem Gerät im Browser durchgeführt, es werden keinerlei Daten an Server gesendet</li>
                                    <li className='text-left'>Einzigartige Nutzerfreundlichkeit: Alle Analysen auf Knopfdruck</li>
                                    <li className='text-left'>Kein Installations- und Wartungsaufwand: Direkt im Browser</li>
                                </ul>
                            </Col>
                        </Row>
                        <hr style={{ borderTop: '3px solid gray' }} />
                        <Row>
                            <Col className='heading text-left'>
                                Messsystem Analyse Type 1: Nutzen, Berechnung und Bewertung der systematischen und zufälligen Abweichungen vom Messnormal (Cg und Cgk)
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left my-2'>
                                Einleitung
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left'>
                                <p>Die Messsystem Analyse Type 1 ist eine unverzichtbare Methode zur Bewertung und Überwachung der Genauigkeit und Zuverlässigkeit von Messsystemen. Durch die Identifizierung systematischer Abweichungen vom Messnormal ermöglicht sie eine effektive Optimierung und Qualitätssteigerung von Messprozessen. In diesem Artikel werden wir den Nutzen der Messsystem Analyse Type 1 erläutern und einen Einblick in die Berechnung und Bewertung der systematischen Abweichungen geben. Besonders relevant sind dabei die Kenngrößen Cg und Cgk, die eine präzise Beurteilung der Messsystemleistung ermöglichen.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left my-2'>
                                Nutzen der Messsystem Analyse Type 1
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left'>
                                <p>Die Messsystem Analyse Type 1 ist ein bewährtes Werkzeug, um die Qualität und Präzision von Messprozessen zu bewerten. Sie bietet zahlreiche Vorteile für Unternehmen, einschließlich:</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ul className="list-disc pl-16">
                                    <li className='text-left'><b>Verbesserung der Produktqualität: </b>Durch die Identifizierung und Minimierung systematischer Abweichungen vom Messnormal wird die Messgenauigkeit erhöht, was zu einer besseren Produktqualität führt.</li>
                                    <li className='text-left'><b>Kosteneinsparungen: </b>Ein optimiertes Messsystem reduziert Ausschuss und Fehlinterpretationen, wodurch Kosten gesenkt werden können.</li>
                                    <li className='text-left'><b>Kundenvertrauen: </b>Zuverlässige Messergebnisse erhöhen das Vertrauen der Kunden in die Produkte und Dienstleistungen eines Unternehmens.</li>
                                    <li className='text-left'><b>Prozessoptimierung: </b>Eine fundierte Analyse der Messsysteme ermöglicht die Identifizierung von Verbesserungspotenzialen in den Prozessen, was zu Effizienzsteigerungen führt.</li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left subHeadingText'>
                                Systematische Abweichung vom Messnormal ("Bias")
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left'>
                                <p>
                                    Die systematische Abweichung vom Messnormal, auch als Bias bezeichnet, spielt eine entscheidende Rolle bei der Messsystem Analyse Type 1. Diese Abweichung tritt auf, wenn das Messsystem wiederholt Messwerte liefert, die systematisch vom tatsächlichen Wert abweichen. Ein Bias kann positive oder negative Werte aufweisen und deutet darauf hin, dass das Messsystem systematische Fehler enthält. Die systematische Abweichung kann verschiedene Ursachen haben, wie z. B. Kalibrierungsprobleme, Umwelteinflüsse oder Fehler in der Messausrüstung. Durch die Berechnung des Biases kann die Genauigkeit des Messsystems bewertet werden. Ein Bias nahe null zeigt an, dass das Messsystem nur geringfügige oder keine systematischen Abweichungen aufweist. Eine größere systematische Abweichung kann jedoch die Genauigkeit und Zuverlässigkeit der Messungen beeinflussen. Daher ist es von entscheidender Bedeutung, den Bias im Rahmen der Messsystem Analyse Type 1 zu bewerten und geeignete Maßnahmen zu ergreifen, um systematische Fehler zu reduzieren und die Messgenauigkeit zu verbessern.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left subHeadingText'>
                                Cg - Maß für die zufällige Abweichungen des Messmittels
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left'>
                                <p>
                                    Cg ist eine wichtige Kennzahl, die in der Messsystem Analyse Type 1 verwendet wird, um die Gesamtabweichung eines Messsystems zu bewerten. Es berücksichtigt sowohl die zufälligen als auch die systematischen Abweichungen vom Messnormal. Die Berechnung erfolgt anhand der Standardabweichung der Messwerte und des Biases.
                                </p>
                                <p><b>Cg = (20% * (OSG – USG)) / (k * Standardabweichung)</b></p>
                                <p>Wo OSG die Obere Spezifikationsgrenze und USG die Untere Spezifikationsgrenze ist. Der Faktor „k“ steht standardmäßig auf 4 (siehe VDA Band 5), bei besonders wichtigen Merkmalen (Schlüsselmerkmalen) wird für „k“ auch 6 genommen.</p>
                                <p>Ein höherer Cg-Wert deutet auf eine geringere Gesamtabweichung und somit auf eine höhere Messsystemfähigkeit hin.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left'>
                                Cgk - Maß für die Fähigkeit des Messmittels
                            </Col>
                        </Row>
                        <Row>
                            <Col className='heading text-left'>
                                Messsystemanalyse – msa typ 1 online & kostenlos mit dem Analyse Tool von QM-Datalab
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p className='text-left'>
                                    Analysiere unkompliziert und kostenlos online deine Messdaten. Füge einfach deine Daten in das QM-Datalab Tool ein, wähle aus welche Daten du auswerten möchtest und QM-Datalab erstellt dir alle benötigten Analysen, Kennwerte und Diagramme.
                                </p>
                                <p className='text-left subHeadingText'>Die großen Vorteile von QM-Datalab</p>
                                <ul className="list-disc pl-16">
                                    <li className='text-left'>Von QM-Manager für QM-Manager: Genau die Analysen, die du brauchst</li>
                                    <li className='text-left'>100% Datensicherheit: Die Analysen werden nur auf deinem Gerät im Browser durchgeführt, es werden keinerlei Daten an Server gesendet</li>
                                    <li className='text-left'>Einzigartige Nutzerfreundlichkeit: Alle Analysen auf Knopfdruck</li>
                                    <li className='text-left'>Kein Installations- und Wartungsaufwand: Direkt im Browser</li>
                                </ul>
                            </Col>
                        </Row>
                        <hr style={{ borderTop: '3px solid gray' }} />
                        <Row>
                            <Col className='heading text-left'>
                                Messsystemanalyse – msa typ 1: Nutzen, Berechnung & Bewertung der systematischen und zufälligen Abweichungen vom Messnormal (Cg und Cgk)
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText my-3'>
                                Einleitung
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p className='text-left'>
                                    Die Messsystemanalyse – msa typ 1 ist eine unverzichtbare Methode zur Bewertung und Überwachung der Genauigkeit und Zuverlässigkeit von Messsystemen. Durch die Identifizierung systematischer Abweichungen vom Messnormal ermöglicht sie eine effektive Optimierung und Qualitätssteigerung von Messprozessen. In diesem Artikel werden wir den Nutzen der Messsystemanalyse – msa typ 1 erläutern und einen Einblick in die Berechnung und Bewertung der systematischen Abweichungen geben. Besonders relevant sind dabei die Kenngrößen Cg und Cgk, die eine präzise Beurteilung der Messsystemleistung ermöglichen.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left'>
                                Nutzen Messsystemanalyse – msa typ 1
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p className='text-left'>
                                    Die Messsystemanalyse – msa typ 1 ist ein bewährtes Werkzeug, um die Qualität und Präzision von Messprozessen zu bewerten. Sie bietet zahlreiche Vorteile für Unternehmen, einschließlich:
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ul className="list-disc pl-16 text-left">
                                    <li><b>Verbesserung der Produktqualität: </b>Durch die Identifizierung und Minimierung systematischer Abweichungen vom Messnormal wird die Messgenauigkeit erhöht, was zu einer besseren Produktqualität führt.</li>
                                    <li><b>Kosteneinsparungen: </b>Ein optimiertes Messsystem reduziert Ausschuss und Fehlinterpretationen, wodurch Kosten gesenkt werden können.</li>
                                    <li><b>Kundenvertrauen: </b>Zuverlässige Messergebnisse erhöhen das Vertrauen der Kunden in die Produkte und Dienstleistungen eines Unternehmens.</li>
                                    <li><b>Prozessoptimierung: </b>Eine fundierte Analyse der Messsysteme ermöglicht die Identifizierung von Verbesserungspotenzialen in den Prozessen, was zu Effizienzsteigerungen führt.</li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='heading my-3'>
                                Systematische Abweichung vom Messnormal („Bias“)
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-left'>
                                <p>
                                    Die systematische Abweichung vom Messnormal, auch als Bias bezeichnet, spielt eine entscheidende Rolle bei der Messsystem Analyse Type 1. Diese Abweichung tritt auf, wenn das Messsystem wiederholt Messwerte liefert, die systematisch vom tatsächlichen Wert abweichen. Ein Bias kann positive oder negative Werte aufweisen und deutet darauf hin, dass das Messsystem systematische Fehler enthält. Die systematische Abweichung kann verschiedene Ursachen haben, wie z. B. Kalibrierungsprobleme, Umwelteinflüsse oder Fehler in der Messausrüstung. Durch die Berechnung des Biases kann die Genauigkeit des Messsystems bewertet werden. Ein Bias nahe null zeigt an, dass das Messsystem nur geringfügige oder keine systematischen Abweichungen aufweist. Eine größere systematische Abweichung kann jedoch die Genauigkeit und Zuverlässigkeit der Messungen beeinflussen. Daher ist es von entscheidender Bedeutung, den Bias im Rahmen der Messsystemanalyse – msa typ 1 zu bewerten und geeignete Maßnahmen zu ergreifen, um systematische Fehler zu reduzieren und die Messgenauigkeit zu verbessern.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left'>
                                Cg - Maß für die zufällige Abweichungen des Messmittels
                            </Col>
                        </Row>
                        <Row className='text-left'>
                            <Col>
                                <p>
                                    Cg ist eine wichtige Kennzahl, die in der Messsystemanalyse – msa typ 1 verwendet wird, um die Gesamtabweichung eines Messsystems zu bewerten. Es berücksichtigt sowohl die zufälligen als auch die systematischen Abweichungen vom Messnormal. Die Berechnung erfolgt anhand der Standardabweichung der Messwerte und des Biases.
                                </p>
                                <p>
                                    <b>Cg = (20% * (OSG – USG)) / (k * Standardabweichung)</b>
                                </p>
                                <p>
                                    Wo OSG die Obere Spezifikationsgrenze und USG die UntereSpezifikationsgrenze ist. Der Faktor „k“ steht standardmäßig auf 4 (siehe VDA Band 5), bei besonders wichtigen Merkmalen (Schlüsselmerkmalen) wird für „k“ auch 6 genommen.
                                </p>
                                <p>
                                    Ein höherer Cg-Wert deutet auf eine geringere Gesamtabweichung und somit auf eine höhere Messsystemfähigkeit hin.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='subHeadingText text-left'>
                                Cgk - Maß für die Fähigkeit des Messmittels
                            </Col>
                            <p className='text-left'>
                                Zusätzlich zu Cg ist Cgk ein weiteres wichtiges Maß in der Messsystemanalyse – msa typ 1. Cgk bezieht sich auf die Fähigkeit des Messsystems, die Toleranzvorgaben einzuhalten. Es berücksichtigt die systematische Abweichung und die Streuung der Messwerte im Vergleich zur Toleranzbreite.
                            </p>
                            <p className='text-left'><b>Cgk = (10% * (Toleranz - abs(Bias)) / (0,5 * k * Standardabweichung)</b></p>
                            <p className='text-left'>Wo:
                                <br /><i>Toleranz = OSG – USG</i>
                                <br /><i>Bias</i> = systematische Abweichung vom Messnormal = Mittelwert der Messwert – Referenzwert.
                                <br />Für den Faktor „k“ wird standardmäßig wieder 4 angenommen (siehe VDA Band 5). Bei besonders wichtigen Merkmalen (Schlüsselmerkmalen) wird für „k“ auch 6 genommen.
                                <br />Ein hoher Cgk-Wert zeigt an, dass das Messsystem die Toleranzvorgaben effektiv einhält und somit qualitativ hochwertige Messungen ermöglicht.
                            </p>
                        </Row>
                        <Row>
                            <Col className='subHeadingText my-3'>
                                Fazit – Messsystemanalyse – msa typ 1
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p className='text-left'>
                                    Die Messsystemanalyse – msa typ 1 ist ein unverzichtbares Werkzeug zur Bewertung und Optimierung von Messprozessen. Durch die Berechnung der systematischen Abweichungen, insbesondere mit den Kenngrößen Cg und Cgk, kann die Genauigkeit und Zuverlässigkeit von Messsystemen präzise beurteilt werden. Dies ermöglicht Unternehmen, die Produktqualität zu verbessern, Kosten zu senken und das Kundenvertrauen zu stärken. Eine fundierte Analyse der Messsysteme unterstützt auch die Prozessoptimierung und Effizienzsteigerung. Die Messsystem Analyse Type 1 ist somit ein essenzieller Bestandteil eines effektiven Qualitätsmanagements.
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default MSAType1;